import classNames from 'classnames';
import React from 'react';

import '@eika/card-style/src/ShortcutCard.scss';
import { Icon, IconTypes } from '@eika/icon';

export interface ShortcutCardProps extends Omit<React.PropsWithoutRef<JSX.IntrinsicElements['a']>, 'href'> {
    icon?: IconTypes;
    text?: string;
    link?: string;
}

export interface ShortcutCardGroupProps {
    title: string;
    children?: React.ReactNode;
}

const ShortcutCard: React.FC<ShortcutCardProps> = ({ icon, text, link, className, ...rest }) => {
    return (
        <a href={link} className={classNames(className, `sgw-shortcut__content`)} aria-label={text} {...rest}>
            {icon && (
                <span className="card-icon__wrapper">
                    <Icon type={icon} className="sgw-shortcut__icon card-icon" />
                </span>
            )}
            {text && <span className="sgw-shortcut__text">{text}</span>}
            <span className="card-icon__wrapper">
                <Icon
                    type={IconTypes.PIL_STOR_HOEYRE_24}
                    className="sgw-shortcut__icon--desktop icon card-icon icon--24"
                />
                <Icon type={IconTypes.PIL_HOEYRE} className="sgw-shortcut__icon--mobile icon card-icon icon--24" />
            </span>
        </a>
    );
};

const ShortcutCardGroup: React.FC<ShortcutCardGroupProps> = ({ title, children }) => {
    return (
        <div className="sgw-content">
            <h2 className="sgw-shortcut__header">{title}</h2>
            <nav className="sgw-shortcut">{children}</nav>
        </div>
    );
};

export { ShortcutCard, ShortcutCardGroup };
